import BaseController from '../BaseController';
import Controller, { OnAfterFetch, OnClick, OnMount, OnReadSuccess } from '@philips-internal/oswald-ui-core/lib/client';
import { FragmentNames, PatientDisplacementPersonInformationAliases } from '../../codegen';
import InformationBarUtils from '../commons/header/information-bar-header-utils';
import './patient-displacement-person-information.css';
import './patient-displacement-history.css';
import { ClickEvent, ReadEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { ApplicationRoute } from '../../constants/routes';
import { applicationContext } from '@philips-internal/oswald-ui-foundation';
import { Endpoint } from '../../constants/endpoints';
import { BrokerService, HttpService } from '@philips-internal/oswald-ui-core/lib/services';
import { Inject } from '@odinjs/odin';
import { BarcodeData, BaseModalProps, FetchAPI, ModalService, TabControlAPI, TabWithContentAPI } from '@philips-internal/oswald-ui-components';
import { FoundationUtils } from '../../utils/foundation-utils';
import { FunctionName, PATIENT_DISPLACEMENT_99676Parameters,  } from '../../utils/parameters';
import { EventData } from '@philips-internal/oswald-ui-core/lib/component/event';
import { ToastMsgUtils } from '../../utils/toastmsg-utils';
import { DataContext } from '@philips-internal/oswald-ui-core/lib/component';
import { ModalType } from '@philips-internal/oswald-ui-constants';
let isBarCodePrescr = false;
@Controller({ component: PatientDisplacementPersonInformationAliases.LAYOUT_PERSON_INFORMATION, fragment: FragmentNames.PATIENT_DISPLACEMENT_PERSON_INFORMATION })
class PatientDisplacementPersonInformationControler extends BaseController {
  @Inject(PatientDisplacementPersonInformationAliases.FETCH_SAIDAS)
  private readonly fetchSaidas!: FetchAPI;

  @Inject(PatientDisplacementPersonInformationAliases.TAB_SAIDAS)
  private readonly tabSaida!: TabWithContentAPI;

  @Inject(PatientDisplacementPersonInformationAliases.TAB_CHEGADAS)
  private readonly tabChegada!: TabWithContentAPI;

  @Inject(PatientDisplacementPersonInformationAliases.TAB_TROCA_LOCAL_PA)
  private readonly tabTrocaLocalPa!: TabWithContentAPI;

  @Inject(PatientDisplacementPersonInformationAliases.PATIENT_DISPLACEMENT_PERSONAL_INFORMATION_TAB_CONTROL)
  private readonly tabControl!: TabControlAPI;

  @Inject(PatientDisplacementPersonInformationAliases.TAB_INFO)
  private readonly tabInfo!: TabWithContentAPI;

  @OnMount({ target: PatientDisplacementPersonInformationAliases.LAYOUT_PERSON_INFORMATION })
  onMountInput(): void {
    this.mountInformationBar();
  }

  @OnMount({ target: PatientDisplacementPersonInformationAliases.LAYOUT_SAIDAS })
  onMountTabs(): void {
    const allowedViewOutAndArrivalsTab = FoundationUtils.findModuleParam(
      FunctionName.PATIENT_DISPLACEMENT_99676,
      PATIENT_DISPLACEMENT_99676Parameters.ALLOW_DISPLAY_MENUS_EXIT_AND_ARRIVALS
    ) === 'S';

    const allowedViewChangePatientLocation = FoundationUtils.findModuleParam(
      FunctionName.PATIENT_DISPLACEMENT_99676,
      PATIENT_DISPLACEMENT_99676Parameters.ALLOW_DISPLAY_CHANGE_PATIENT_LOCATION
    ) === 'S';

    this.tabSaida.setVisible(allowedViewOutAndArrivalsTab);
    this.tabChegada.setVisible(allowedViewOutAndArrivalsTab);
    this.tabTrocaLocalPa.setVisible(allowedViewChangePatientLocation);

    if (!allowedViewOutAndArrivalsTab && !allowedViewChangePatientLocation) {
      this.tabControl.setDefaultTab(PatientDisplacementPersonInformationAliases.TAB_INFO);
      this.tabInfo.setVisible(true);
    } else if (allowedViewChangePatientLocation && !allowedViewOutAndArrivalsTab) {
      this.tabControl.setDefaultTab(PatientDisplacementPersonInformationAliases.TAB_TROCA_LOCAL_PA);
    }
  }

  @OnReadSuccess({ target: PatientDisplacementPersonInformationAliases.BARCODE_PRESCR })
  onReadSucesstBarCode(event: ReadEvent<BarcodeData>): void {
    const prescription = event.item.value as unknown as BarcodeData;
    this.context.set({ prescriptionId: prescription });
    this.fetchSaidas.setEndpoint(Endpoint.GET_DEPARTMENTS_BY_PRESCRIPTION);
    this.fetchSaidas.forceFetch();
    isBarCodePrescr = true;
  }

  @OnReadSuccess({ target: PatientDisplacementPersonInformationAliases.BARCODE_ARRIVALS })
  async onReadSucesstBarCodeIncoming(event: ReadEvent<BarcodeData>): Promise<void> {
    const department = event.item as unknown as BarcodeData;
    const route = ApplicationRoute.PATIENT_ARRIVAL_CONFIRMATION;
    this.context.set({ departmentId: department.value });
    if (Number(department.value) === 0) {
      return;
    }
    const params = {
      departmentId: department.value,
      encounterId: this.historyService.getCurrentRouteParams().encounterId,
      limit: 12,
      page: 0
    };

    const response = await HttpService.get(Endpoint.GET_DEPARTMENTS_BY_ENCOUNTER, params);

    if (response.ok) {
      const data = (response).body as { cdSetorAtendimento: string };
      let error = true;
      for (const item of Array.isArray(data) ? data : [data]) {
        if (item.cdSetorAtendimento == department.value) {
          this.redirectToConfirmation(route, item.cdSetorAtendimento, item.dsSetorAtendimento);
          error = false;
          break;
        }
      }
      if (error) {
        ToastMsgUtils.toastErrorMessage('text.message-alert-attention', 'text.sector_not_in_current_attendance');
      }
    } else {
      ToastMsgUtils.toastErrorMessage('tws.error-generic', 'text.contact_system_admin');
    }
  }

  @OnAfterFetch(PatientDisplacementPersonInformationAliases.FETCH_SAIDAS)
  onAfterFetch({ target }: EventData<FetchAPI>): void {
    const data = target.getData() as Array<unknown>;
    if (data.length === 0) {
      return;
    }
    const route = ApplicationRoute.PATIENT_OUT_CONFIRMATION;
    if (isBarCodePrescr && data.length == 1) {
      const value = data[0] as { cdSetorAtendimento: string, dsSetorAtendimento: string };
      this.redirectToConfirmation(route, value.cdSetorAtendimento, value.dsSetorAtendimento);
    }
  }

  @OnClick({ target: PatientDisplacementPersonInformationAliases.TROCAR_LOCAL_BUTTON })
  async onClickTrocaLocal(): Promise<void> {
    const dialogModal: BaseModalProps = {
      focusOnOpen: false,
      fragment: FragmentNames.CHANGE_PATIENT_LOCATION,
      id: FragmentNames.CHANGE_PATIENT_LOCATION,
      title: 'Troca de Local',
      type: ModalType.DEFAULT,
    };
    ModalService.openDialog(dialogModal);
  }

  @OnClick({ target: PatientDisplacementPersonInformationAliases.DECK_SAIDAS })
  async onCardClick(event: ClickEvent): Promise<void> {
    const cdSetorAtendimento = event.value.cdSetorAtendimento as string;
    const dsSetorAtendimento = event.value.dsSetorAtendimento as string;
    const route = ApplicationRoute.PATIENT_OUT_CONFIRMATION;
    this.redirectToConfirmation(route, cdSetorAtendimento, dsSetorAtendimento);
  }

  private mountInformationBar(): void {
    const { patientId, encounterId } =
      this.historyService.getCurrentRouteParams();
    InformationBarUtils.collapsedBar = true;
    InformationBarUtils.allowInfo = true;
    this.context.set({
      encounterId,
      patientId,
    });
  }

  private redirectToConfirmation( route: string, cdSetorAtendimento: string, dsSetorAtendimento: string ): void {
    BrokerService.subscribeToTopic('setChangeData', (context: DataContext) => {
      context.set({ department: dsSetorAtendimento, sector: cdSetorAtendimento });
    });
    applicationContext.redirect(route);
  }
}

export default PatientDisplacementPersonInformationControler;
